import { SynchronizationStatus, TriggerSynchronization } from '@jupiter/shared';
import { api } from '../api';

export const synchronizationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    triggerSynchronization: builder.mutation<void, TriggerSynchronization | undefined>({
      query: (params?: TriggerSynchronization) => ({
        url: 'synchronization/trigger',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: [
        'IRS',
        'Taxes',
        'Invoices',
        'Expenses',
        'SS',
        'VAT',
        'SynchronizationStatus',
        'Dashboard',
        'Entities',
      ],
    }),
    getSynchronizationStatus: builder.query<SynchronizationStatus, void>({
      query: () => 'synchronization/status',
      providesTags: ['SynchronizationStatus'],
    }),
  }),
  overrideExisting: false,
});

export const { useTriggerSynchronizationMutation, useGetSynchronizationStatusQuery } = synchronizationApi;
